import React from 'react';
import css from './WhatHappensSection.module.css';

const STEPS = [
  {
    number: '1',
    title: 'Register Your Project',
    badge: 'Today',
    description: 'Submit your planning reference & create your account.',
  },
  {
    number: '2',
    title: 'Validate Your Application',
    badge: '0–7 days',
    description: "We confirm your project as soon as it's live in the system.",
  },
  {
    number: '3',
    title: 'Connect with Suppliers',
    badge: null,
    description: 'Create your project brief, review costs, and match with suppliers.',
  },
];

const WhatHappensSection = () => {
  return (
    <section id="how-it-works" className={css.section}>
      <div className={css.inner}>
        <h2 className={css.heading}>What happens after you sign up?</h2>

        <div className={css.timeline}>
          {STEPS.map((step, i) => (
            <div key={step.number} className={css.row}>
              {/* Left: number + vertical line */}
              <div className={css.leftCol}>
                <div className={css.circle}>{step.number}</div>
              </div>

              {/* Right: card */}
              <div className={css.card}>
                <div className={css.cardTop}>
                  <h3 className={css.cardTitle}>{step.title}</h3>
                  {step.badge && (
                    <span className={css.badge}>{step.badge}</span>
                  )}
                </div>
                <p className={css.cardDesc}>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatHappensSection;
